import { ComponentChildren, h } from 'preact';
import styled from 'styled-components';

interface CallToActionButtonProps {
  onClick?: (e: any) => void;
  ariaLabel?: string;
  children: ComponentChildren;
  fullWidth?: boolean;
  disabled?: boolean;
}

const CallToActionButtonStyled = styled.button<CallToActionButtonProps>`
  font-weight: 800;
  background-color: black;
  color: white;
  text-transform: uppercase;
  font-size: 14px;
  display: inline-block;
  padding: 12px 24px;
  margin-top: 24px;
  cursor: pointer;
  border: 1px solid black;
  margin: 0 auto;
  &:disabled,
	[disabled] {
		background: #e0e0e0;
		border-color: #e0e0e0;
		color: #636363;
	}
`;

export const CallToActionButton = ({
  onClick = () => null,
  children,
  fullWidth = false,
  ariaLabel,
  disabled = false
}: CallToActionButtonProps) => {
  return (
    <CallToActionButtonStyled
      aria-label={ariaLabel}
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={disabled}
    >
      {children}
    </CallToActionButtonStyled>
  );
};